import { render } from "./ReportShop.vue?vue&type=template&id=f675670c&scoped=true"
import script from "./ReportShop.vue?vue&type=script&lang=js"
export * from "./ReportShop.vue?vue&type=script&lang=js"

import "./ReportShop.vue?vue&type=style&index=0&id=f675670c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f675670c"]])

export default __exports__